import { useParams } from 'react-router-dom';
import useQuery from '@/hooks/useQuery';
import { useMemo } from 'react';
import { getNestedCategory } from '@/domain/categories/helpers';

type UseGridContextProps = {
  components: Record<string, any>;
  autocompleteApiInstance: any;
};

const useGridContext = ({ components, autocompleteApiInstance }: UseGridContextProps) => {
  const params = useParams();
  const category = getNestedCategory(params);
  const query = useQuery();
  return useMemo(
    () => ({
      fetchParams: {
        category,
        ...query,
      },
      components,
      autocompleteApiInstance,
    }),
    [query, category, components, autocompleteApiInstance],
  );
};

export default useGridContext;
